import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useEditProject = (projectId) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      await fetchContext.authAxios.put(`/projects/${projectId}`, data);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(["project", projectId, "info"]);
      },
    }
  );
};
